export default __webpack_public_path__ + "static/media/rubber.34664620.pdf";